import React from 'react';
import Translate from 'react-translate-component';

export function processInvoiceUser (invoiceUser, allInvoiceUsers) {
  if (allInvoiceUsers.length === 0) {
    allInvoiceUsers.push(invoiceUser);
    return allInvoiceUsers;
  }

  for (let i = 0; i<allInvoiceUsers.length; i++) {
    if (allInvoiceUsers[i].userId === invoiceUser.userId || invoiceUser.userId === null) {
      allInvoiceUsers[i].taxkeyId = (invoiceUser.taxkeyId) ? invoiceUser.taxkeyId : allInvoiceUsers[i].taxkeyId;
      allInvoiceUsers[i].total = (invoiceUser.total) ? invoiceUser.total : allInvoiceUsers[i].total;
      allInvoiceUsers[i].saveVacationPay =
        (invoiceUser.saveVacationPay)
        ? invoiceUser.saveVacationPay
        : allInvoiceUsers[i].saveVacationPay;
      allInvoiceUsers[i].saveItp = (invoiceUser.saveItp) ? invoiceUser.saveItp : allInvoiceUsers[i].saveItp;
      allInvoiceUsers[i].allowance = (invoiceUser.allowance) ? invoiceUser.allowance : allInvoiceUsers[i].allowance;
      allInvoiceUsers[i].travel = (invoiceUser.travel) ? invoiceUser.travel : allInvoiceUsers[i].travel;
    }
  }

  return allInvoiceUsers;
}

export function renderExtraInvoicingRows (invoice) {
  switch (invoice.messageType) {
    case 'email':
      const to = <div className='invoice-details-row'>
        <b><Translate content='TO' />: </b>
        {invoice.billingEmails[0]}
      </div>;
      const copy = invoice.billingEmails[1] ? <div className='invoice-details-row'>
        <b><Translate content='COPY' />: </b>
        {invoice.billingEmails[1]}
      </div> : null;
      return (
        <div>
          {to}
          {copy}
        </div>
      );
    case 'sms':
      return (
        <div className='invoice-details-row'>
          <b><Translate content='TO' />: </b>
          {invoice.companyPhone}
        </div>
      );
    case 'e-invoice':
      return (
        <div>
          <div className='invoice-details-row'>
            <b><Translate content='TO' />: </b>
            {invoice.eInvoiceEmail}
          </div>
          <div className='invoice-details-row'>
            <b><Translate content='PO_NUMBER' />: </b>
            {invoice.poNumber}
          </div>
        </div>
      );
    default:
      return null;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/invoice/helper.js
 **/